import { render, staticRenderFns } from "./scanOrdersDialog.vue?vue&type=template&id=2b239d84&"
import script from "./scanOrdersDialog.vue?vue&type=script&lang=js&"
export * from "./scanOrdersDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports